export const abreviarNome = (nome: string, maxLength = 25) => {
  if (nome.length <= maxLength) return nome;

  const palavras = nome.split(' ');
  const primeiraPalavra = palavras[0];
  const ultimaPalavra = palavras[palavras.length - 1];
  const palavrasIntermediarias = palavras.slice(1, -1).map((p) => `${p[0]}.`);

  return [primeiraPalavra, ...palavrasIntermediarias, ultimaPalavra].join(' ');
};
